<!-- Component that implements a list of documents -->
<template lang="html">
  <div>

    <!-- Mensagem mostrada ao clicar no botão "Novo Relatório" -->
    <v-dialog v-model="dialogConfirmaInformacoes" width="450">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Confirma as informações da ação?</v-card-title>

        <!-- Mensagem mostrada em caso de cursos/oficina (39729) ou curso (44194) ou oficina (44195) ou eventos (39730) de extensão -->
        <div
          v-if="projeto.classificacaoSecundaria.id === 39729 || projeto.classificacaoSecundaria.id === 44194 || projeto.classificacaoSecundaria.id === 44195 || projeto.classificacaoSecundaria.id === 39730">

          <v-card-text class="title" align="justify" style="word-break: break-word; margin-top: 10px;">Para preenchimento
            do relatório técnico é necessário que todas as informações estejam atualizadas no sistema , incluindo:
          </v-card-text>

          <v-card-text class="title" align="left" style="word-break: break-word; margin-top: 10px;">- Finalizar a
            participação dos membros da equipe;
          </v-card-text>

          <v-card-text class="title" align="left" style="word-break: break-word; margin-top: 10px;">- Preencher a aba
            Atividades;
          </v-card-text>

          <v-card-text class="title" align="left" style="word-break: break-word; margin-top: 10px;">- Anexar documentação
            comprobatória da ação na aba Arquivos.
          </v-card-text>

        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="toAtualizar()">Atualizar as informações da ação</v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="toAdicionarRelatorio()">As informações já estão atualizadas</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Mensagem informativa no topo da aba -->
    <v-layout wrap justify-space-between
      v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true || usuarioPROEX === true">
      <v-flex xs12>
        <div class="instrucao">
          <v-card outlined>
            <v-card-text class="black--text font-weight-bold">
              Em caso de dúvidas ou sugestões entrar em contato pelo e-mail <a
                href="mailto:suporte.proex@ufes.br">suporte.proex@ufes.br</a>. Já em caso de problemas com o sistema
              entrar em contato pelo <a href="https://redmine.ufes.br/projects/suporte-projetos-extensao/issues/new"
                target="_blank">Sistema de Suporte</a>.
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>

    <!-- Tabela com os relatórios técnicos -->
    <v-data-table :headers="headers" :items="listaRelatorios" :search="search"
      :no-data-text="'Nenhum relatório encontrado.'" must-sort :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
      :items-per-page="itemsPerPage"
      :footer-props="{ itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao }">

      <!-- Link para a tela de visualização do relatório -->
      <template v-slot:item.id="props">
        <router-link
          :to="{ name: 'RelatorioTecnico', params: { idProjeto: idProjeto, idRelatorioExtensao: props.item.id } }">
          Relatório {{ props.item.ordem }}
        </router-link>
      </template>

      <!-- Formata a data inicial do relatório -->
      <template v-slot:item.dtInicial="props">{{ dates.format(props.item.dtInicial) }}</template>

      <!-- Formata a data final do relatório -->
      <template v-slot:item.dtFinal="props">{{ dates.format(props.item.dtFinal) }}</template>

      <!-- Formata o tipo do relatório -->
      <template v-slot:item.tipoRelatorioTecnicoItem="props">
        {{
          props.item.tipoRelatorioTecnicoItem === 1 ? "Relatório Parcial" :
          props.item.tipoRelatorioTecnicoItem === 2 ? "Relatório Parcial com Renovação" :
            props.item.tipoRelatorioTecnicoItem === 3 ? "Relatório Final" : "Tipo Inválido"
        }}
      </template>

      <!-- Formata a situação do relatório -->
      <template v-slot:item.situacaoRelatorioTecnicoItem="props">
        {{
          props.item.situacaoRelatorioTecnicoItem === 1 ? "Em elaboração" :
          props.item.situacaoRelatorioTecnicoItem === 2 ? "Aguardando aprovação" :
            props.item.situacaoRelatorioTecnicoItem === 3 ? "Aprovado" :
              props.item.situacaoRelatorioTecnicoItem === 4 ? "Reprovado" : "Situação inválida"
        }}
      </template>

      <!-- Formata a data de submissão do relatório -->
      <template v-slot:item.dtSubmissaoRelatorio="props">{{ dates.format(props.item.dtSubmissaoRelatorio) }}</template>

      <!-- Formata a data de decisão (aprovação ou reprovação) do relatório -->
      <template v-slot:item.dtDecisaoRelatorio="props">{{
        dates.format(relatorioTecnico.formataDataDecisao(props.item.situacaoRelatorioTecnicoItem,
          props.item.dtAprovacaoRelatorio, props.item.dtReprovacaoRelatorio)) }}</template>

      <!-- Ícones da coluna "Opções" -->
      <template v-slot:item.opcoes="props">

        <!-- Ícone de submeter para aprovação -->
        <c-tooltip-btn icon="open_in_browser" color="primary"
          v-if="props.item.situacaoRelatorioTecnicoItem === 1 && (relatorioHabilitadoAcaoRegistroTardio() === false) && (situacaoAtivo() || situacaoAguardandoRelatorio()) && (usuarioCoordenador() || usuarioAdministrador())"
          :disabled="situacaoAtivo() === true" tooltip="Submeter para aprovação"
          disabled-tooltip="É possível submeter o relatório para aprovação apenas quando a ação de extensão está na situação Aguardando envio de relatório"
          @click="toSubmeter(props.item.id)"></c-tooltip-btn>

        <!-- Ícone para gerar PDF do relatório -->
        <c-tooltip-btn
          v-if="(props.item.situacaoRelatorioTecnicoItem === 2 || props.item.situacaoRelatorioTecnicoItem === 3) && usuarioPermissaoEspelhoRelatorio()"
          icon="picture_as_pdf" color="primary" tooltip="Gerar PDF" @click="toGerarPDF(props.item.id)"></c-tooltip-btn>

        <!-- Ícone de aprovar -->
        <c-tooltip-btn v-if="usuarioPermissaoAprovarRelatorio(props.item.situacaoRelatorioTecnicoItem)"
          icon="done_outline" color="green" tooltip="Aprovar" @click="toAprovar(props.item.id)"></c-tooltip-btn>

        <!-- Ícone de devolver -->
        <c-tooltip-btn v-if="usuarioPermissaoDevolverReprovarRelatorio(props.item.situacaoRelatorioTecnicoItem)"
          icon="not_interested" color="red" tooltip="Devolver" @click="toDevolver(props.item.id)"></c-tooltip-btn>

        <!-- Ícone de reprovar -->
        <c-tooltip-btn v-if="usuarioPermissaoDevolverReprovarRelatorio(props.item.situacaoRelatorioTecnicoItem)"
          icon="cancel" color="black" tooltip="Reprovar" @click="toReprovar(props.item.id)"></c-tooltip-btn>

      </template>

      <!-- Texto de rodapé que informa a quantidade de relatórios -->
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaRelatorios.length }} relatórios
      </template>

    </v-data-table>

    <c-card-footer :projeto="this.projeto" :extensao="this.extensao" :habilitaBotaoGerarPDFAcao=false>
      <!--
        Um novo relatório pode ser criado apenas quando a ação de extensão está na situação "Ativo" ou "Aguardando relatório".
        Além disso, caso a ação de extensão esteja em alguma das situações mencionadas, só é possível criar um novo relatório
        se não existir nenhum relatório na situação "Em elaboração" ou "Aguardando aprovação" e também se não existir nenhum
        relatório com data final igual à data de conclusão da ação de extensão.
      -->
      <v-btn
        v-if="(habilitaNovoRelatorio() && (possivelAdicionar === true)) || (relatorioHabilitadoAcaoRegistroTardio() && (possivelAdicionar === true))"
        color="primary" text @click="btnNovoRelatorio">
        Novo relatório
      </v-btn>

      <!--
        Desabilita o botão e exibe mensagem caso não seja possível adicionar um novo relatório.
      -->
      <v-tooltip top v-if="habilitaNovoRelatorio() && possivelAdicionar === false">
        <template v-slot:activator="{ on }">
          <div v-on="on" style="float: left;">
            <v-btn disabled color="primary" text @click="btnNovoRelatorio">Novo relatório</v-btn>
          </div>
        </template>
        <span>{{ motivo }}</span>
      </v-tooltip>
    </c-card-footer>

  </div>
</template>

<script>
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import CardFooter from '@/components/c-card-footer'
import ConfirmDialog from '@/components/c-confirm-dialog'
import TootipButton from '@/components/c-tooltip-btn'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import relatorioTecnico from '@/utils/relatorioTecnico'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    dialogConfirmaInformacoes: false,
    listaRelatorios: [],
    periodoRelatorio: {},
    possivelAdicionar: null,
    motivo: null,
    dates: dates,
    relatorioTecnico: relatorioTecnico,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
    // Nome das colunas da aba.
    headers: [
      { text: 'Número', align: 'left', width: '15%', value: 'id' },
      { text: 'Início', align: 'left', width: '10%', value: 'dtInicial' },
      { text: 'Fim', align: 'left', width: '10%', value: 'dtFinal' },
      { text: 'Tipo', align: 'left', width: '15%', value: 'tipoRelatorioTecnicoItem' },
      { text: 'Situação', align: 'left', width: '15%', value: 'situacaoRelatorioTecnicoItem' },
      { text: 'Submissão', align: 'left', width: '10%', value: 'dtSubmissaoRelatorio' },
      { text: 'Decisão', align: 'left', width: '10%', value: 'dtDecisaoRelatorio' },
      { text: 'Opções', align: 'left', width: '15%', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    truncate: function (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    btnNovoRelatorio: function () {
      if (this.relatorioHabilitadoAcaoRegistroTardio()) {
        this.toAdicionarRelatorio()
      } else {
        this.dialogConfirmaInformacoes = true
      }
    },
    toSubmeter: function (idRelatorioExtensao) {
      this.$router.push({ name: 'SubmeterRelatorio', params: { idProjeto: this.idProjeto, idRelatorio: idRelatorioExtensao } })
    },
    toAprovar: function (idRelatorioExtensao) {
      this.$router.push({ name: 'AprovarRelatorio', params: { idProjeto: this.idProjeto, idRelatorio: idRelatorioExtensao } })
    },
    toDevolver: function (idRelatorioExtensao) {
      this.$router.push({ name: 'DevolverRelatorio', params: { idProjeto: this.idProjeto, idRelatorio: idRelatorioExtensao } })
    },
    toReprovar: function (idRelatorioExtensao) {
      this.$router.push({ name: 'ReprovarRelatorio', params: { idProjeto: this.idProjeto, idRelatorio: idRelatorioExtensao } })
    },
    toRelatorio: function () {
      this.$router.push({ name: 'Relatorio', params: { idProjeto: this.idProjeto } })
    },
    toAtualizar: function () {
      this.$router.push({ name: 'EditarExtensao', params: { idProjeto: this.idProjeto } })
    },
    toAdicionarRelatorio: function () {
      this.$router.push({ name: 'NovoRelatorio', params: { idProjeto: this.projeto.idProjeto } })
    },
    toGerarPDF: function (idRelatorioExtensao) {
      this.$router.push({ name: 'RelatorioTecnicoPDF', params: { idProjeto: this.idProjeto, idRelatorioExtensao: idRelatorioExtensao } })
    },
    // Verifica se a ação de extensão está na situação "Preenchimento incompleto".
    situacaoPreenchimentoIncompleto: function () {
      if (this.projeto.situacao.item === 15) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando aprovação".
    situacaoAguardandoAprovacao: function () {
      if (this.projeto.situacao.item === 16) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function () {
      if (this.projeto.situacao.item === 18) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function () {
      if (this.projeto.situacao.item === 20) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Inadimplente".
    situacaoInadimplente: function () {
      if (this.projeto.situacao.item === 3) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Relatório aguardando aprovação".
    situacaoRelatorioAguardandoAprovacao: function () {
      if (this.projeto.situacao.item === 22) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Concluído".
    situacaoConcluido: function () {
      if (this.projeto.situacao.item === 19) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Cancelado".
    situacaoCancelado: function () {
      if (this.projeto.situacao.item === 5) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a situação da ação de extensão permite adicionar um novo relatório.
    situacaoAcaoExtensaoHabilitada: function () {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio() || this.situacaoInadimplente()) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function () {
      if (this.administrador === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function () {
      if ((this.projeto.funcao != null && this.projeto.funcao.item === 1)) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function () {
      if (this.projeto.assessor === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é usuário Proex.
    usuarioProex: function () {
      if (this.usuarioPROEX === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado está habilitado para adicionar um novo relatório.
    usuarioHabilitado: function () {
      if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor()) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
    relatorioHabilitadoAcaoRegistroTardio: function () {
      if (this.projeto.relatorioFinalHabilitado === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o botão 'Novo Relatório' deve ser habilitado.
    habilitaNovoRelatorio: function () {
      if (this.situacaoAcaoExtensaoHabilitada() && this.usuarioHabilitado()) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado possui permissão para visualizar o espelho do relatório.
    usuarioPermissaoEspelhoRelatorio: function () {
      if (this.situacaoInadimplente() || this.situacaoAtivo() || this.situacaoAguardandoRelatorio() || this.situacaoRelatorioAguardandoAprovacao() || this.situacaoConcluido() || this.situacaoCancelado() || (this.relatorioHabilitadoAcaoRegistroTardio() && this.situacaoAguardandoAprovacao())) {
        if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor() || this.usuarioProex()) {
          return true
        } else {
          return false
        }
      }
    },
    // Verifica se o usuário logado possui permissão para aprovar um relatório técnico.
    usuarioPermissaoAprovarRelatorio: function (situacaoRelatorio) {
      //if (this.situacaoRelatorioAguardandoAprovacao()) {
        if (situacaoRelatorio === 2) {
          if (this.usuarioAdministrador()) {
            return true
          } else {
            return false
          }
        }
      //}
    },
    // Verifica se o usuário logado possui permissão para devolver ou reprovar um relatório técnico.
    usuarioPermissaoDevolverReprovarRelatorio: function (situacaoRelatorio) {
      if (this.relatorioHabilitadoAcaoRegistroTardio() === false) { //this.situacaoRelatorioAguardandoAprovacao() &&
        if (situacaoRelatorio === 2) {
          if (this.usuarioAdministrador()) {
            return true
          } else {
            return false
          }
        }
      }
    }
  },
  mounted: function () {
    // Busca os relatórios técnicos.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios.' })
    projetos.getRelatoriosDoProjeto(this.idProjeto)
      .then(response => {
        this.listaRelatorios = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios.' })
      })

    // Endpoint chamado para verificar se é possível adicionar um novo relatório técnico.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Verificando se é possível adicionar um novo relatório.' })
    projetos.getPeriodoRelatorio(this.idProjeto)
      .then(response => {
        this.periodoRelatorio = response.data
        this.possivelAdicionar = this.periodoRelatorio.possivelAdicionar
        this.motivo = this.periodoRelatorio.motivo
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando período do relatório.' })
      })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip,
    'c-card-footer': CardFooter,
    'c-tooltip-btn': TootipButton,
    'c-confirm-dialog': ConfirmDialog
  }
}
</script>

<style lang="css" slot-scoped>
.instrucao {
  text-align: center;
  margin-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// projeto-relatorios-tabela.vue?7efe0064